
















import { Component, Emit, Vue } from 'vue-property-decorator';
import FieldSelect from '@/components/form/FieldSelect.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { StoreActions } from '@/store';

@Component({
  components: {
    FieldSelect,
  },
  mixins: [validationMixin],
  validations: {
    year: { required },
  },
  computed: {
    ...mapGetters(['years']),
  }
})
export default class MemberRemovalModal extends Vue {
  year = null;

  @Emit()
  close() {
    return true;
  }

  async submit() {
    if (confirm(`Weet je zeker dat je alle leden van voor ${this.year} wilt verwijderen?`)) {
      await this.$store.dispatch(StoreActions.PruneMembers, this.year);
      this.close();
    }
  }



}
